import Reflux from 'reflux';
import UserNotification from 'util/UserNotification';
import { qualifyUrl } from 'util/URLUtils';
import fetch from 'logic/rest/FetchProvider';
import { RefluxActions } from 'stores/StoreTypes';

import { LicenseStatus as LicenseStoreState } from 'archive/types';

const licenseStatusUrl = '/plugins/org.graylog.plugins.license/licenses/status/for-subject?subject=/license/enterprise/forwarder';

type ForwarderLicenseActionsType = RefluxActions<{
  getLicenseStatus: () => Promise<any>,
}>;

export const ForwarderLicenseActions: ForwarderLicenseActionsType = Reflux.createActions({
  getLicenseStatus: { asyncResult: true },
});

const ForwarderLicenseStore = Reflux.createStore<LicenseStoreState>({
  listenables: [ForwarderLicenseActions],

  getInitialState() {
    return {
      status: undefined,
      missing: true,
      loading: true,
    };
  },

  getLicenseStatus() {
    const promise = fetch('GET', qualifyUrl(licenseStatusUrl));
    const errorHandler = this._errorHandler('Fetching forwarder license failed', 'Could not retrieve forwarder license');

    promise.then((response) => {
      this.trigger({ status: response.status, missing: false, loading: false });
    }, (error) => {
      try {
        // We don't want to create a user notification for missing licenses
        if (error.additional.status !== 404) {
          errorHandler(error);
        }
      } catch (e) {
        errorHandler(error);
      }

      this.trigger({ status: null, missing: true, loading: false });
    });

    ForwarderLicenseActions.getLicenseStatus.promise(promise);
  },

  _errorHandler(message, title) {
    return (error) => {
      let errorMessage;

      try {
        errorMessage = error.additional.body.message;
      } catch (e) {
        errorMessage = error.message;
      }

      UserNotification.error(`${message}: ${errorMessage}`, title);
    };
  },
});

export default ForwarderLicenseStore;
